import { useBreakpointValue } from '@silo/ui';

export const useIsChartsFeatureOn = () => {
  const isChartsBreakpointOn = useBreakpointValue(false, { md: true });

  return isChartsBreakpointOn;
};
